import React from 'react'
import Consultations from '@services/Consultations'
import { Panel } from '@modules/admin/groups/Panel.Index'
import { USER_GROUPS } from '@modules/admin/groups/constants'
import { createUserGroupColumns } from '@modules/admin/groups/actions'
import { useTranslation } from 'react-i18next'
import SimpleModal from '@modules/admin/common/modal/simpleModal'

const CompanyGroupModal = ({ company, className, hide }) => {
  const { t } = useTranslation()
  const filters = { company_ids: [company.id] }
  const client = Consultations.userGroups
  return (
    <SimpleModal
      hideModal={hide}
      loading={false}
      className={className}
      title={t('userGroups')}
      template={
        <Panel
          kind={USER_GROUPS}
          className={'group-panel'}
          buttonText={t('newUserGroups')}
          columns={createUserGroupColumns(t)}
          client={client}
          filters={filters}
        />
      }
    />
  )
}
export default CompanyGroupModal
